export default __webpack_public_path__ + "static/media/baseline-home-24px.8eaec3be.svg";